import React from "react";
import "./HeaderStyles.css";

function Logo({ children, ...restProps }) {
  return (
    <div>
      <a className="logo-container" href="/" {...restProps}>
        {children}
        <img className="logo" href="/" src="./images/misc/once_logo.png" alt="OncePlay logo" />
      </a>
    </div>
  );
}

export default Logo;
